import { TableSettings } from "../../../../tableSettings";

export const adjustBalanceTable: TableSettings = {
  tableVersion: 10044,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '221px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: '',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3,
    },
    {
      Header: 'Date',
      accessor: 'invoiceDate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8,
    },
    {
      Header: 'Account Number',
      accessor: 'invoiceNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13,
    },
    {
      Header: 'Head Amount',
      accessor: 'invoiceAmt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: 'Detail Amount',
      accessor: 'detAmt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: 'Paid Amount',
      accessor: 'paidAmt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: 'Actual Paid Amount',
      accessor: 'aPaidAmt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: 'Duty Paid Amount',
      accessor: 'dutyPaidAmt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: 'Actual Duty Paid Amount',
      accessor: 'aDutyPaidAmt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: 'Error Amount',
      accessor: 'errorAmt',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.5,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.5,
    },
  ]
};

export const sendFaxTable: TableSettings = {
  tableVersion: 10040,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '221px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: 'Select',
      accessor: 'isSelected',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.71,
    },
    {
      Header: 'Company',
      accessor: 'companyName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 35.71,
    },
    {
      Header: 'Dept',
      accessor: 'dept',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.29,
    },
    {
      Header: 'Name',
      accessor: 'contactName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 21.43,
    },
    {
      Header: 'Fax',
      accessor: 'faxNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.86,
    },
  ]
};

export const emailCcTable: TableSettings = {
  tableVersion: 10040,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '380px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.00,
    },
    {
      Header: 'Company Name',
      accessor: 'company',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 24.00,
    },
    {
      Header: 'Dept',
      accessor: 'dept',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 10.00,
    },
    {
      Header: 'Contact',
      accessor: 'contact',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.00,
    },
    {
      Header: 'Email Address',
      accessor: 'email',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 30.00,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.00,
    },
  ]
};

export const memoFileTable: TableSettings = {
  tableVersion: 10042,
  overflowX: 'hidden',
  overflowY: 'scroll',
  height: '380px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  columns: [
    {
      Header: 'Select',
      accessor: 'selected',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 11.32,
    },
    {
      Header: 'File Name',
      accessor: 'file',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 28.30,
    },
    {
      Header: 'Date',
      accessor: 'date',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15.09,
    },
    {
      Header: 'Memo Title',
      accessor: 'title',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 41.51,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.78,
    },
  ]
};
